import AddressBlock from "@components/shared/AddressBlock/AddressBlock";
import AddressDisplay from "@components/shared/AddressDisplay/AddressDisplay";
import OwEditModeToggle from "@components/shared/OwEditModeToggle/OwEditModeToggle";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import IAddress from "@models/IAddress";
import INewAddress from "@models/INewAddress";
import IOrder from "@models/IOrder";
import IUpdateOrderEntryDetailDTO from "@models/DTO/IUpdateOrderEntryDetailDTO";
import { ChangeEvent, useEffect, useState } from "react";

type Props = {
    order: IOrder;
    isReadOnly: boolean;
    updateOrderDetails: (data: Partial<IUpdateOrderEntryDetailDTO>) => void;
};

export const EcommerceOrderCheckoutShipTo = (props: Props) => {
    const [editMode, setEditMode] = useState(false);
    const [address, setAddress] = useState<IAddress | undefined>(props.order.Ship_To);

    useEffect(() => {
        setAddress(props.order.Ship_To);
    }, [props.order.Ship_To]);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        setAddress({ ...(address || {}), [name]: value } as IAddress);
    };

    const cancelEdit = () => {
        setAddress(props.order.Ship_To);
        setEditMode(false);
    };

    const saveEdit = () => {
        props.updateOrderDetails({ Ship_To: address as IAddress });
        setEditMode(false);
    };

    return (
        <div className={"EcommerceOrderCheckoutShipTo"}>
            <div>
                <div className="d-flex align-items-center">
                    <OwTitle title={"1_shipping"} tag="h5" isUnderline={true} />
                    {!props.isReadOnly && (
                        <div className="mb-2 mt-2">
                            <OwEditModeToggle
                                className="ms-2"
                                editMode={editMode}
                                cancelEditFn={cancelEdit}
                                saveEditFn={saveEdit}
                                toggleEditFn={() => setEditMode(!editMode)}
                            />
                        </div>
                    )}
                </div>

                {editMode ? (
                    <AddressBlock
                        className="mb-2"
                        showName={true}
                        showCompanyName={true}
                        address={address}
                        fn={handleChange}
                        updateEntireAddressFn={(_address: IAddress | INewAddress) => setAddress(_address as IAddress)}
                    />
                ) : (
                    <AddressDisplay showName={true} showCompanyName={true} address={address} />
                )}
            </div>
        </div>
    );
};
